export default "__VITE_ASSET__on4zhicM__"